import { UserUpdate } from '../types';
import axiosInstance from './axiosInstance';

export async function updateUser(user: UserUpdate) {
  await axiosInstance.post('/user', user);
}
